// extracted by mini-css-extract-plugin
var _1 = "tjs-chart-panel-download-button__btn-download tjs-_buttons__btn";
var _2 = "tjs-chart-panel-download-button__btn-download tjs-_buttons__btn";
export { _1 as "btn-download", _2 as "btnDownload" }
export default { "btn-download": _1, "btnDownload": _2 }
